import React from "react";
import { useHistory } from "react-router";
import Images from "../../assets/Images/0_ExportImages";
import { loginAPI, registerAPI, saveUserKey } from "../../services/postAPIs";
import "./register.style.scss";
export default function Register() {
  const emailRegex = /([\w\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?/gm;
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [details, setDetails] = React.useState({
    username: "",
    password: "",
    cPassword: "",
    fullName: "",
  });
  const autoLogin = async () => {
    let res = await loginAPI({
      username: details.username,
      password: details.password,
      projectId: 3,
    });
    if (res.data.success) {
      localStorage.setItem("userToken", res.data.data);
      localStorage.setItem("username", details.username);
      let resTwo = await saveUserKey(res.data.data);
      if (resTwo.data.success) {
        history.push("/home/transaction");
      } else {
        history.push("/home/transaction");
      }
    } else {
    }
  };
  const handleClick = async () => {
    let res;
    setLoading(true);
    try {
      let temp = {
        username: details.username,
        password: details.password,
        fullName: details.fullName,
        roleId: 2,
        projectId: 3,
      };
      res = await registerAPI(temp);
      if (res.data.success) {
        autoLogin();
      } else {
        setError(res.data.message);
        setLoading(false);
      }
    } catch (error) {
      setError("Invalid Email");
      setLoading(false);
      console.error(res);
    }
  };
  return (
    <div className="register-main">
      <header>
        <nav>
          <div>
            <img src={Images.ethScan} />
          </div>
        </nav>
      </header>
      <section>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            loading ||
            !emailRegex.test(details.username) ||
            !details.password ||
            details.password !== details.cPassword
              ? console.log()
              : handleClick();
          }}
        >
          <div className="login-form-titles">
            <h1>
              <b>Join Us</b>
            </h1>
            {/* <p>Login to your account</p> */}
          </div>
          <div className="login-form-inputs">
            <p>Full name</p>
            <input
              value={details.fullName}
              onChange={(e) => {
                setError("");
                setDetails({ ...details, [e.target.name]: e.target.value });
              }}
              name="fullName"
              placeholder="Ex. John SIlva"
              required
            />
            <h6 className={!error ? "d-none" : "display-error"}>{error}</h6>
          </div>
          <div className="login-form-inputs">
            <p>Email</p>
            <input
              type="email"
              value={details.username}
              onChange={(e) => {
                setError("");
                setDetails({ ...details, [e.target.name]: e.target.value });
              }}
              name="username"
              autoComplete="new-email"
              placeholder="Email"
              required
            />
            <h6 className={!error ? "d-none" : "display-error"}>{error}</h6>
          </div>
          <div className="login-form-inputs">
            <p>Password</p>
            <input
              type="password"
              placeholder="Password"
              onChange={(e) => {
                setError("");
                setDetails({ ...details, [e.target.name]: e.target.value });
              }}
              name="password"
              autoComplete="new-password"
              minLength={8}
              value={details.password}
              required
            />
          </div>
          <div className="login-form-inputs">
            <p>Confirm Password</p>
            <input
              value={details.cPassword}
              onChange={(e) => {
                setError("");
                setDetails({ ...details, [e.target.name]: e.target.value });
              }}
              style={
                details.password &&
                details.cPassword.length >= 8 &&
                details.password !== details.cPassword
                  ? { border: "1px solid red" }
                  : {}
              }
              type="password"
              name="cPassword"
              placeholder="Confirm Password"
              required
            />
          </div>
          <div className="login-form-bottom">
            <div>
              <p>
                If you already have an account,{" "}
                <span onClick={() => history.push("/login")}>Sign in</span>
              </p>
              <p>
                Or explore{" "}
                <span onClick={() => history.push("/home")}>
                  Blockchain Machine
                </span>
              </p>
            </div>
            <button
            // onClick={()=>!emailRegex.test(details.username)?setError("Invalid Email"): handleClick()}
            >
              {loading ? "Please wait..." : "Register"}
            </button>
          </div>
        </form>
      </section>
      <footer></footer>
    </div>
  );
}
